/**
 * UTILITAIRES POUR LA GESTION DES TRANSACTIONS
 * Centralise toutes les fonctions réutilisables pour les transactions
 */

/**
 * Formate un montant avec séparateur de milliers français
 * @param {number} amount - Montant à formater
 * @returns {string} Montant formaté
 */
export const formatAmount = (amount) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  }).format(amount || 0);
};


/**
 * Formate le nombre avec espaces (séparateur de milliers)
 * @param {number} number - Nombre à formater
 * @returns {string} Nombre formaté
 */
export const formatNumberWithSpaces = (number) => {
  if (number === null || number === undefined || isNaN(number)) return '0';
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

/**
 * Filtre et trie les transactions selon les critères
 * @param {Array} transactions - Liste des transactions
 * @param {string} statusFilter - Filtre de statut
 * @param {string} dateFilter - Filtre de date
 * @param {string} sortOrder - Ordre de tri
 * @returns {Array} Transactions filtrées et triées
 */
export const filterAndSortTransactions = (transactions, statusFilter, dateFilter, sortOrder) => {
  let filteredAndSorted = [...transactions];

  // Filtrage par statut
  if (statusFilter) {
    filteredAndSorted = filteredAndSorted.filter(transaction => transaction.status === statusFilter);
  }

  // Filtrage par date
  if (dateFilter) {
    const today = new Date();
    let startDate;

    switch (dateFilter) {
      case 'today':
        startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        break;
      case 'this_week':
        const firstDayOfWeek = today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1);
        startDate = new Date(today.getFullYear(), today.getMonth(), firstDayOfWeek);
        break;
      case 'this_month':
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        break;
      default:
        break;
    }

    if (startDate) {
      filteredAndSorted = filteredAndSorted.filter(transaction => new Date(transaction.creationDate) >= startDate);
    }
  }

  // Tri par quantité
  if (sortOrder === 'asc_qty') {
    filteredAndSorted.sort((a, b) => a.quantity - b.quantity);
  } else if (sortOrder === 'desc_qty') {
    filteredAndSorted.sort((a, b) => b.quantity - a.quantity);
  }

  return filteredAndSorted;
};